module.exports = __webpack_public_path__ + "media/public/fonts/QanelasMedium/QanelasMedium-d50a8d5139664b4b8541173f733c7628.woff";